import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../context/AuthContext';
import { useTenantPath } from '../hooks/useTenant';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { buildPath } = useTenantPath();
  const location = useLocation();

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Laden...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    // Aktuellen Pfad (inkl. Query-Parameter) als returnTo mitgeben.
    // Nur interne Pfade (beginnen mit '/') werden weitergegeben.
    const currentPath = location.pathname + location.search;
    const loginPath = buildPath('/login');
    const params = new URLSearchParams();
    if (currentPath && currentPath !== '/' && currentPath !== loginPath) {
      params.set('returnTo', currentPath);
    }
    const paramsStr = params.toString();
    return <Navigate to={`${loginPath}${paramsStr ? `?${paramsStr}` : ''}`} replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProtectedRoute;
